module.exports = "<nv-react-component component=\"AdminToolsPanel\"></nv-react-component>";